import type { Resolvers, UndoRedoCommandSet } from '../../../../generated';
import { MAX_STACK_SIZE, undoRedoCommandMap } from '../state';

export const resolvers: Resolvers = {
  Mutation: {
    executeRedoCommand: () => {
      const commandMap = undoRedoCommandMap.get('default');
      const commandSet: UndoRedoCommandSet = commandMap.redos[0];
      if (!commandSet) return null;
      const updatedCommandMap = {
        ...commandMap,
        redos: commandMap.redos.slice(1),
        undos: [commandSet, ...commandMap.undos].slice(0, MAX_STACK_SIZE),
        activeCommand: commandSet.redo,
      };
      undoRedoCommandMap.set('default', updatedCommandMap);
      return null;
    },
  },
};
